import { BaseResource } from './base';
import {
  CommissionRuleDto,
  CreateCommissionRuleDto,
  UpdateCommissionRuleDto,
  CommissionRuleFiltersDto,
} from '../models/commissions';
import { RequestOptions, PaginatedResponseDto } from '../types';

export class CommissionPromotionsResource extends BaseResource {
  private basePath = 'commissions/promotions';

  async createPromotion(
    data: CreateCommissionRuleDto,
    options?: RequestOptions,
  ): Promise<CommissionRuleDto> {
    return this.client.post<CommissionRuleDto>(this.basePath, data, options);
  }

  async getPromotion(id: string, options?: RequestOptions): Promise<CommissionRuleDto> {
    return this.client.get<CommissionRuleDto>(`${this.basePath}/${id}`, undefined, options);
  }

  async listPromotions(
    params?: CommissionRuleFiltersDto,
    options?: RequestOptions,
  ): Promise<PaginatedResponseDto<CommissionRuleDto>> {
    return this.paginate<CommissionRuleDto>(this.basePath, params, options);
  }

  async updatePromotion(
    id: string,
    data: UpdateCommissionRuleDto,
    options?: RequestOptions,
  ): Promise<CommissionRuleDto> {
    return this.client.put<CommissionRuleDto>(`${this.basePath}/${id}`, data, options);
  }

  async deletePromotion(id: string, options?: RequestOptions): Promise<{ success: boolean }> {
    return this.client.delete<{ success: boolean }>(`${this.basePath}/${id}`, options);
  }

  async activatePromotion(id: string, options?: RequestOptions): Promise<CommissionRuleDto> {
    return this.client.put<CommissionRuleDto>(`${this.basePath}/${id}/activate`, {}, options);
  }

  async deactivatePromotion(id: string, options?: RequestOptions): Promise<CommissionRuleDto> {
    return this.client.put<CommissionRuleDto>(`${this.basePath}/${id}/deactivate`, {}, options);
  }

  async validatePromotion(
    data: CreateCommissionRuleDto,
    options?: RequestOptions,
  ): Promise<{ valid: boolean; errors?: string[]; conflicts?: CommissionRuleDto[] }> {
    return this.client.post<{ valid: boolean; errors?: string[]; conflicts?: CommissionRuleDto[] }>(
      `${this.basePath}/validate`,
      data,
      options,
    );
  }

  async estimateImpact(
    id: string,
    options?: RequestOptions,
  ): Promise<{
    estimatedContracts: number;
    estimatedCommissions: number;
    estimatedCost: number;
  }> {
    return this.client.get<{
      estimatedContracts: number;
      estimatedCommissions: number;
      estimatedCost: number;
    }>(`${this.basePath}/${id}/impact`, undefined, options);
  }
}
